exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, "body,html{font-family:Open Sans,serif;font-size:14px;font-weight:300}.hero.is-success{background:#f2f6fa}.hero.is-success .nav,.hero .nav{-webkit-box-shadow:none;box-shadow:none}.box{margin-top:5rem}.avatar{margin-top:-70px;padding-bottom:20px}.avatar img{padding:5px;background:#fff;border-radius:50%;-webkit-box-shadow:0 2px 3px hsla(0,0%,4%,.1),0 0 0 1px hsla(0,0%,4%,.1);box-shadow:0 2px 3px hsla(0,0%,4%,.1),0 0 0 1px hsla(0,0%,4%,.1)}input{font-weight:300}p{font-weight:700}p.subtitle{padding-top:1rem}.box input{width:100%}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-4638cc07","scoped":false,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/pages/Home.vue
// module id = 35
// module chunks = 0